import {
	setDrawModeState,
	toggleDeleteFacetsMode,
} from 'store/slices/ToolSlice';
import {
	setEnableFacetEdit
} from 'store/slices/RoofEditSlice';

import { getSelectedFacets, TOOL_ACTION } from 'store/selectors/toolSelector';
import { AppDispatch } from 'store';
import { enableRoofToolLines } from 'store/slices/RoofToolLinesSlice';
import { store } from 'store'; 

export const enableAction = (dispatch: AppDispatch, action: TOOL_ACTION) => {
	const map: Partial<Record<TOOL_ACTION, () => void>> = {
		[TOOL_ACTION.DRAW_FACET]: () => dispatch(setDrawModeState({ enabled: true })),
		[TOOL_ACTION.EDIT_FACET]: () => dispatch(setEnableFacetEdit({ isEnable: true })),
		[TOOL_ACTION.DELETE_FACET]: () => dispatch(toggleDeleteFacetsMode({ enable: true })),
		[TOOL_ACTION.EDIT_EDGES]: () => dispatch(enableRoofToolLines({ shouldEnable: true, initialData: getSelectedFacets(store.getState())})),
	};

	map[action]?.();
};

export const disableAction = (dispatch: AppDispatch, action: TOOL_ACTION) => {
	const map: Partial<Record<TOOL_ACTION, () => void>> = {
		[TOOL_ACTION.DRAW_FACET]: () => dispatch(setDrawModeState({ enabled: false })),
		[TOOL_ACTION.EDIT_FACET]: () => dispatch(setEnableFacetEdit({ isEnable: false })),
		[TOOL_ACTION.DELETE_FACET]: () => dispatch(toggleDeleteFacetsMode({ enable: false })),
		[TOOL_ACTION.EDIT_EDGES]: () => dispatch(enableRoofToolLines({ shouldEnable: false})),
	};

	map[action]?.();
};
